module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "ack",
      "title": "Acknowledgments and Author’s Note"
    }
  }, [_c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("Acknowledgments and Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX1"
  }, [_vm._v("First and foremost, Mr. Wilson would like to express his regrets to the numerous individuals whom, due to the limitations of writing time and length of this work, he did not include in his memoir. Mr. Wilson and I express our appreciation to those whose time and effort contributed to the completion of the book. Much thanks must be extended to Detroit political consultant Adolph Mongo, who introduced me to Mr. Wilson and made possible the writing of a historically important memoir and lasting friendship. Our editor, and my close friend, Professor Roy Kotynek, proved invaluable in his direction and initial reading of the manuscript. In the area of photography and art direction we are grateful for the contributions of Michael T. Paradise and Darien Nemer, both of whom went far beyond our expectations. Mr. Wilson’s daughter and son-in-law, Sharon and Burton Cardwell, have provided much assistance as well.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Thanks must be given to Detroiters Gus Adams, Johnnie Bassett, Alberta Adams, Carl Hill, and Jackie McLeod. We thank the staff of the Detroit Public Library’s Burton Historical Collection, most notably David Poremba, whose assistance proved very helpful in the acquisition of archival photographs. Our appreciation also goes out to members of the Charter Township of Shelby Historical Committee and Idlewild’s Inspector Norm Burns. My personal debt is to my wife, Gretta Abu-Isa, a patient companion and a wellspring of support.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be8c8cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Acknowledgments.vue
// module id = 75
// module chunks = 0